/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgRecordCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentcolor" {...props}>
    <circle cx={8} cy={8} r={8}>
      <animate
        attributeName="r"
        attributeType="XML"
        begin="0.7s"
        dur="2s"
        repeatCount="indefinite"
        values="8;6;8"
      />
    </circle>
  </svg>
)
export default SvgRecordCircleIcon
